<button class="normalized-button" mat-icon-button [matBadge]="notificationCount" [matBadgeHidden]="badgeHidden" (click)="openNotifications()">
    <mat-icon>notifications</mat-icon>
</button>